import React, { useState,useEffect,useRef } from 'react';
import './classes/LookingForAgent.css';
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  isValidPhoneNumber,getCountryCallingCode
} from 'react-phone-number-input'
import { configData } from "../config";
import Select from 'react-dropdown-select';
import { useParams} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Helmet } from 'react-helmet';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";
import LookingForAgentView from './LookingForAgentView';


const LookingForAgentEdit = () => {
  const initialForm = {   
    first_name:'',
    last_name:'',
    street_address:'',
    address_cont:'',
    city_town_province:'',
    state:'',
    zip_post_code:'',
    country:'US',
    phone:'',
    email:'',
    retype_email:'',
    sport_played:'',
    specific_sport:'',
    positions_played:'',
    university_attended:'',
    high_school:'',
    high_school_city:'',
    high_school_state:'',
    awards:'',
    professional_experience:'',
    test_info:'',
    year:'',
    month:'',
    day:'',
    height:'',
    ft:'',
    in:'',
    height_unit:'Imperial',
    weight:'',
    weight_unit:'lb',
    facebook_url:'',
    facebook_followers:'',
    instagram_url:'',
    instagram_followers:'',
    your_linkedin_url:'',
    linkedin_followers:'',
    tiktok_url:'',
    tiktok_followers:'',
    twitter_url:'',
    twitter_followers:'',
    youtube_url:'',
    youtube_followers:'',
    "1st_reference_name":'',
    "1st_reference_last_name":'',
    job_title_1:'',
    team_or_club_1:'',
    email_address_1:'',
    "1st_reference_phone":'',
    "2nd_reference_name":'',
    "2nd_reference_last_name":'',
    job_title_2:'',
    team_or_club_2:'',
    email_address_2:'',
    "2nd_reference_phone":'',
    "3rd_reference_name":'',
    "3rd_reference_last_name":'',
    job_title_3:'',
    team_or_club_3:'',
    email_address_3:'',
    "3rd_reference_phone":'',
    pageURL: window.location.href,
  };
 
  const [formData, setFormData] = useState(initialForm);
  const [buttonText, setButtonText] = useState('Submit');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const[success,setSuccess] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
   const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
  var loggedin_drupaluid = localStorage.getItem('drupal_uid');
   const drupal_uid = localStorage.getItem('drupal_uid');
       const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
          var loggedin_domain = drupal_domain_url;
          if(localStorage.getItem('loggedin_domain')) {
          loggedin_domain = localStorage.getItem('loggedin_domain');
          } 
         
          const {id} = useParams();

  const inputStyle = {
  first_name: {
    border: fieldErrors.first_name ? '2px solid red' : '1px solid #777'
  },
  last_name: {
    border: fieldErrors.last_name ? '2px solid red' : '1px solid #777'
  },
  street_address: {
    border: fieldErrors.street_address ? '2px solid red' : '1px solid #777'
  },
  city_town_province: {
    border: fieldErrors.city_town_province ? '2px solid red' : '1px solid #777'
  },
  state: {
    border: fieldErrors.state ? '2px solid red' : '1px solid #777'
  },
  zip_post_code: {
    border: fieldErrors.zip_post_code ? '2px solid red' : '1px solid #777'
  },
  country: {
    border: fieldErrors.country ? '2px solid red !important' : '1px solid #777'
  },
   phone: {
    border: fieldErrors.phone  ? '2px solid red' : '1px solid #777'
  },
   email: {
    border: fieldErrors.email ? '2px solid red' : '1px solid #777'
  },
  retype_email: {
    border: fieldErrors.retype_email ? '2px solid red' : '1px solid #777'
  },
  sport_played: {
    border: fieldErrors.sport_played ? '2px solid red' : '1px solid #777'
  },
  positions_played: {
    border: fieldErrors.positions_played ? '2px solid red' : '1px solid #777'
  },
  year: {
    border: fieldErrors.year ? '2px solid red' : '1px solid #777'
  },
  month: {
    border: fieldErrors.month ? '2px solid red' : '1px solid #777'
  },
   day: {
    border: fieldErrors.day ? '2px solid red' : '1px solid #777'
  },
   height: {
    border: fieldErrors.height ? '2px solid red' : '1px solid #777'
  },
   ft: {
    border: fieldErrors.ft ? '2px solid red' : '1px solid #777'
  },
   in: {
    border: fieldErrors.in ? '2px solid red' : '1px solid #777'
  },
   weight: {
    border: fieldErrors.weight ? '2px solid red' : '1px solid #777'
  }
};
const sportsOptions = [
  { value: "45", label: "Action Sports" },
  { value: "2", label: "Baseball" },
  { value: "3", label: "Basketball" },
  { value: "7", label: "Boxing" },
  { value: "8", label: "Cricket" },
  { value: "42", label: "Extreme Sports" },
  { value: "1", label: "Football (American)" },
  { value: "5", label: "Golf" },
  { value: "6", label: "Hockey" },
  { value: "39", label: "Motor Sports" },
  { value: "44", label: "Olympic" },
  { value: "41", label: "Other" },
  { value: "16", label: "Polo" },
  { value: "18", label: "Rodeo" },
  { value: "46", label: "Rugby" },
  { value: "4", label: "Soccer" },
  { value: "30", label: "Tennis" },
  { value: "31", label: "Track and Field" }
];
  const [calendarOpen, setCalendarOpen] = useState(false);

  const currentYear = new Date().getFullYear();
const maxYear = currentYear - 17; // 17 years difference
const years = Array.from({ length: maxYear - 1944 + 1 }, (_, i) => 1944 + i);


  const months = [
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" },
  ];

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCalendarSelect = (date) => {
    //const year = date.getFullYear().toString();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();

    // setFormData({ year, month, day });
    setFormData(prev => ({
      ...prev,
      year,
      month,
      day
    }));
    setCalendarOpen(false);
  };

  const [reference1, setReference1] = useState(true);
  const [reference2, setReference2] = useState(true);
  const [reference3, setReference3] = useState(true);

    const [countriesList, setCountriesList] = useState([]);
    const [statelist, setStateList] = useState({});
   const [selectedcountry, setSelectedCountry] = useState([{ label: 'United States', value: 'US' }]);
    const [selectedState, setSelectedState] = useState('');

    const [detailedview, setDetailedView] = useState(true);
    const [athletePicture, setAthletePicture] = useState({});
    const [nextId, setNextId] = useState({});
    const [prevId, setPrevId] = useState({});
    const [user, setUser] = useState({});
    const app_url = configData.APP_URL;
     const [toggle, setToggle] = useState(2);
    const {tab} = useParams();
    const navigate = useNavigate();
function updateToggle(aid) {
  setToggle(aid);

  if (aid === 1) {
    navigate(`/node/1080/submission/${id}`);
  }

  if (aid === 2) {
    navigate(`/node/1080/submission/${id}/edit`);
  }
   if (aid === 3) {
    navigate(`/node/1080/submission/${id}/delete`);
  }
}

    
          useEffect(() => {
              if(tab == "view") {
              setToggle(1);
        
            }
            if(tab == "edit") {
              setToggle(2);
            }
            if(tab == "delete") {
              setToggle(3);
            }
         
             } ,[tab]);
        useEffect(() => {
            retrieveCountriesList();
            retrieveStateList();
            retrievelookingforagentview();
            retrieveuserloggedinroles();
            getuserloggedinroles()
            // if(loggedin_drupaluid > 0) {
            // retrievelookingforagentsubmission();
            // }
        }, []);

    

  

        const handleOpen = () => {
            setSelectedCountry([]);
            setFormData(prevState => ({
            ...prevState,
              country:''
            }));

        };
const handleChange = (e) => {
  if (!e?.target) return console.error("handleChange called incorrectly:", e);

  const { name, value } = e.target;

  //  Handle height unit toggle (Metric <-> Imperial)
  if (name === "height_unit") {
    setFormData((prev) => ({
      ...prev,
      height_unit: value,
      height: "",
      ft: "",
      in: "",
    }));

    // Clear related height errors
    setFieldErrors((prev) => ({
      ...prev,
      height: false,
      ft: false,
      in: false,
      height_unit: false,
    }));

    // Remove height-related messages
    setErrors((prevMessages) =>
      prevMessages.filter(
        (msg) =>
          ![
            "height",
            "ft",
            "inches",
            "cm",
          ].some((keyword) => msg.toLowerCase().includes(keyword))
      )
    );

    return; // stop here
  }

  //Normal field update
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  
 
};
async function getuserloggedinroles() {
   
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
             // setUserLoggedInId(responsedata.data.user); 
              setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
       
  }
    async function  retrieveuserloggedinroles() {
        const response = await fetch(
        app_url+'viewprofile/getuserloggedinroles',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.result == "Success") {
            setUser(responsedata.data.user);
        }
    }
  async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
 async function  retrievelookingforagentview() {
        const response = await fetch(
        app_url+'smwwathlete/lookingforagentviewdetails?id='+id,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            setDetailedView(responsedata.data.result);
            setAthletePicture(responsedata.data.picture);
            setNextId(responsedata.data.next_id);
            setPrevId(responsedata.data.prev_id);
        }
    }
//    async function  retrievelookingforagentsubmission() {
//     if(loggedin_drupaluid > 0) {
//         const response = await fetch(
//         app_url+'smwwathlete/lookingforagentsubmissiondetails?loggedin_drupaluid='+loggedin_drupaluid,
//             {
//                 method: "GET",
        
//                 headers: {
//                 'Content-Type': 'application/json',
//                 },
//             }
//         )
//         const responsedata = await response.json();
//         if(responsedata.data.msg == "Already submitted") {
          
//           setShowmsg(responsedata.data.result);

//         }
//         if(responsedata.data.msg == "Not submitted") {
          
//           setShowmsg('');

//         }
//       }
//     }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);   
    
  }
const isValidBasicPhone = (phone) => {
  const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
  return cleaned.length >= 7 && cleaned.length <= 15;
};
const validateForm = () => {
  const newFieldErrors = {};
  const newMessages = [];

  if (!formData.first_name) {
    newFieldErrors.first_name = true;
    newMessages.push("First Name field is required.");
  }  
    if (!formData.last_name) {
    newFieldErrors.last_name = true;
    newMessages.push("Last Name field is required.");
  }
  if (!formData.street_address) {
    newFieldErrors.street_address = true;
    newMessages.push("Street Address field is required.");
  }
  if (!formData.city_town_province) {
    newFieldErrors.city_town_province = true;
    newMessages.push("City/Town/Province field is required.");
  }
   if (!formData.state) {
    newFieldErrors.state = true;
    newMessages.push("State field is required.");
  }
    if (!formData.zip_post_code) {
    newFieldErrors.zip_post_code = true;
    newMessages.push("Zip/Post Code field is required.");
  }
     if (!formData.country) {
    newFieldErrors.country = true;
    newMessages.push("Country field is required.");
  }
  // REQUIRED CHECK (fix for your issue)
if (!formData.phone || formData.phone.trim() === "") {
  newFieldErrors.phone = true;
  newMessages.push("Your Phone Number field is required.");
}

 // Phone validation block (your logic, fixed)

if (formData.phone && formData.phone.trim()) {
  const digitsOnly = formData.phone.replace(/\D/g, '');

  try {
    let codeLength = 0;

    if (formData.phoneCountry) {
      codeLength = getCountryCallingCode(formData.phoneCountry).length;
    } else {
      const match = digitsOnly.match(/^\d{1,3}/);
      if (match) codeLength = match[0].length;
    }

    if (digitsOnly.length > codeLength) {
      // Full number entered → must validate
      if (!isValidPhoneNumber(formData.phone)) {
        newFieldErrors.phone = true;
        newMessages.push('Invalid Primary Phone Number');
      }
    } else {
      // Only country code → treat as empty (NO state mutation!)
      newFieldErrors.phone = true;
      newMessages.push('Your Phone Number field is required.');
    }

  } catch (err) {
    if (!isValidPhoneNumber(formData.phone)) {
      newFieldErrors.phone = true;
      newMessages.push('Invalid Primary Phone Number');
    }
  }
}
if (!formData.email) {
  newFieldErrors.email = true;
  newMessages.push("Your Email Address field is required.");
} else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
  newFieldErrors.email = true;
  newMessages.push("Invalid Email Format.");
}
if (!formData.retype_email) {
  newFieldErrors.retype_email = true;
  newMessages.push("Your Retype Email Address field is required.");
} else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.retype_email)) {
  newFieldErrors.retype_email = true;
  newMessages.push("Invalid Retype Email Format.");
}

 if (formData.email !== formData.retype_email) {
  newFieldErrors.retype_email = true;
  newMessages.push('Email and Retype Email should match.');
}

  if (!formData.sport_played) {
    newFieldErrors.sport_played = true;
    newMessages.push("Sport Played field is required.");
  }
 
  if (!formData.positions_played) {
    newFieldErrors.positions_played = true;
    newMessages.push("Primary Position field is required.");
  }
if (!formData.month || !formData.day || !formData.year) {
  if (!formData.year) newFieldErrors.year = true;
  if (!formData.month) newFieldErrors.month = true;
  if (!formData.day) newFieldErrors.day = true;

  newMessages.push('Please select your date of birth');
}

  

  // Height
  if (formData.height_unit === 'Imperial') {
  if (!formData.ft || !formData.in) {
    newFieldErrors.ft = true;
    newFieldErrors.in = true;
    newMessages.push('Please enter height in feet and inches.');
  }
}
if (formData.height_unit === 'Metric') {
  if (!formData.height) {
    newFieldErrors.height = true;
    newMessages.push('Please enter height in cm.');
  }
}


  // Weight
  if (!formData.weight) {
  newFieldErrors.weight = true;
  newMessages.push('Please enter your weight.');
}

  if (formData["email_address_1"]) {
    if(formData["email_address_1"].trim()) {
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email_address_1)) {
  newFieldErrors.email_address_1 = true;
  newMessages.push("The email format in the first reference is invalid.");
}}}
  if (formData["email_address_2"]) {
    if(formData["email_address_2"].trim()) {
if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email_address_2)) {
  newFieldErrors.email_address_2 = true;
  newMessages.push("The email format in the second reference is invalid.");
}}}
  if (formData["email_address_3"]) {
    if(formData["email_address_3"].trim()) {
if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email_address_3)) {
  newFieldErrors.email_address_3 = true;
  newMessages.push("The email format in the third reference is invalid.");
}}}
if (formData["email_address_1"]) {
  if (formData.email === formData.email_address_1) {
    newFieldErrors.email_address_1 = true;
    newMessages.push('Please enter a valid email for your 1st reference, you cannot refer yourself.');
  }
}
if (formData["email_address_2"]) {
  if (formData.email === formData.email_address_2) {
    newFieldErrors.email_address_2 = true;
    newMessages.push('Please enter a valid email for your 2nd reference, you cannot refer yourself.');
  }
}
if (formData["email_address_3"]) {
  if (formData.email === formData.email_address_3) {
    newFieldErrors.email_address_3 = true;
    newMessages.push('Please enter a valid email for your 3rd reference, you cannot refer yourself.');
  }
}

if ((formData["email_address_1"]) || (formData["email_address_2"]) || (formData["email_address_3"])) {
  const emails = [
    formData.email_address_1,
    formData.email_address_2,
    formData.email_address_3
  ];

  const emailFields = ['email_address_1', 'email_address_2', 'email_address_3'];

  let duplicateFound = false;

  for (let i = 0; i < emails.length; i++) {
    for (let j = i + 1; j < emails.length; j++) {
      if (emails[i] && emails[j] && emails[i] === emails[j]) {
        newFieldErrors[emailFields[i]] = true;
        newFieldErrors[emailFields[j]] = true;
        duplicateFound = true;
      }
    }
  }

  if (duplicateFound) {
    newMessages.push('Please enter a valid email for your reference. You cannot use the same email for multiple references.');
  }
}

  if (formData["1st_reference_phone"]) {
    if(formData["1st_reference_phone"].trim()) {
  if (!isValidBasicPhone(formData["1st_reference_phone"])) {
    newMessages.push('The phone number in the first reference is invalid.');
  }
}
}
  if (formData["2nd_reference_phone"]) {
    if(formData["2nd_reference_phone"].trim()) {
  if (!isValidBasicPhone(formData["2nd_reference_phone"])) {
    newMessages.push('The phone number in the second reference is invalid.');
  }
}
}
  if (formData["3rd_reference_phone"]) {
    if(formData["3rd_reference_phone"].trim()) {
  if (!isValidBasicPhone(formData["3rd_reference_phone"])) {
    newMessages.push('The phone number in the third reference is invalid.');
  }
}
}

  setFieldErrors(newFieldErrors);
  setErrors(newMessages);

  return newMessages.length === 0;
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setSuccess("");
  setErrors([]);
  if (!validateForm()) { 
    window.scrollTo(0, 0);
    return;
  }
     setButtonText('Submitting...');
    setIsButtonDisabled(true);
    const response = await fetch(app_url+'', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
       if(data.data.result === "user_created") {
         setSuccess("Your changes have been saved successfully.");
          setErrors([]);
          setFieldErrors({});
           setFormData(initialForm);
              setButtonText('Submit');
            setIsButtonDisabled(false);

          window.scrollTo(0, 0);
       }
       else  {        
        window.scrollTo(0, 0);
       }
window.scrollTo(0, 0);
 
   
};
       const handleDelete = async (e) => {
            e.preventDefault(); 
   // alert("are you sure you want to delete this submission" );
           const response = await fetch(app_url+'', {
          method: 'POST',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
          });
          const data = await response.json();
          if(data.data.msg === "Success") {
            navigate('/node/1080/webform-results', { state: { message: "Submission Deleted" } });
          }
         
        
    
        };


  return (
     <div id="main" className='looking-for-agent-form-main'>  
      <Helmet><title>{`Submission #${detailedview.id}`}</title></Helmet>    
        <div class="left"></div>
        
         <div class="center left-center">
             <div className='looking-for-agent-form-container lookingforagent-view-container'>
         
           {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                <>
                      <ul className="tabs primarya">
                        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                        {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) &&
                        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>}
                        <li className= {toggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>Delete</a></li>
                        {/* )} */}
                      </ul>
                        <div  className= {toggle === 1? "show-content" : "content"}>
                                                  <LookingForAgentView />
                                              </div>
                                            </>  }
                         
                                 { userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) &&
                                             <div  className= {toggle === 2? "show-content" : "content"}>
                                                {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
        {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
          </div>
          
       
        )}
                      <nav>
                        {/* {prevId && */}
                            <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/node/1080/submission/"+prevId}>Previous submission</a>
                      {/* }  */}
                         {/* {nextId &&  */}
                            <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/node/1080/submission/"+nextId}>Next submission</a>
                         {/* }  */}
                    </nav>
                    <div style={{clear:"both"}}></div>
                    <div>
                        {/* Submission Info */}
                        <fieldset className="submission-info" style={{padding:"10px"}}>
                        <legend>Submission information</legend>

                        <div className="user-picture">
                            <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/user/"+user.drupal_uid+"/view"} title="View user profile.">
                            <img
                                src={athletePicture}
                                alt="User profile"
                            />
                            </a>
                        </div>
                            <div>Form: <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/lookingforagent.php"}>Looking for agent</a></div>
                            <div>Submitted by <span><a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/user/"+user.drupal_uid+"/view"}>{detailedview.email}</a></span></div>
                            <div>{detailedview.created}</div>
                            <div>{detailedview.ip_address}</div>
                        </fieldset>
                    </div>
                <h1>Request An Agent</h1>
                <p><img alt="" 
                 src="/basic/web/images/agent/agency_head_new3.png"
                 style={{"width": "100%"}}/></p>
                <p>Sports Management Worldwide is an international full-service sports agency with an extensive network of Agent Advisors serving athletes throughout the world. It all starts with the form below, which will help us get to know you a little better.</p>
                <p>After filling out this short application, one of our Agent Advisors will contact you within one business day to assess your goals and set you on the road to success!</p>
                   <form onSubmit={handleSubmit}>
                         <div className="form-item">
                         <label htmlFor="edit-submitted-first-name">First Name <span className="form-required" title="This field is required.">*</span></label>
                         <input 
                            type="text"
                            id="edit-submitted-first-name"
                            name="first_name" 
                            value={formData.first_name}
                            size="60" 
                            maxlength="128"
                            className={fieldErrors.first_name ? 'input-error' : ''}
                            style={inputStyle.first_name}
                            onChange={handleChange}
                            />
                            </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-last-name">Last Name <span className="form-required" title="This field is required.">*</span></label>
                         <input 
                            type="text"
                            id="edit-submitted-last-name"
                            name="last_name" 
                            value={formData.last_name}
                            size="60" 
                            maxlength="128" 
                            className={fieldErrors.last_name ? 'input-error' : ''}
                            style={inputStyle.last_name}
                            onChange={handleChange}
                        />
                        </div>
                          <div className="form-item">
                        <label htmlFor="edit-submitted-street-address">Street Address <span className="form-required" title="This field is required.">*</span></label>
                         <input 
                            type="text"
                            id="edit-submitted-street-address"
                            name="street_address" 
                            value={formData.street_address}
                            size="60" 
                            maxlength="128" 
                            className={fieldErrors.street_address ? 'input-error' : ''}
                            style={inputStyle.street_address}
                            onChange={handleChange}
                        />
                        </div>
                             <div className="form-item">
                        <label htmlFor="edit-submitted-address-cont">Address (cont) </label>
                         <input 
                            type="text"
                            id="edit-submitted-address-cont"
                            name="address_cont" 
                            value={formData.address_cont}
                            size="60" 
                            maxlength="128"
                            onChange={handleChange}
                        />
                        </div>
                           <div className="form-item">
                        <label htmlFor="edit-submitted-city-town-province">City / Town / Province <span className="form-required" title="This field is required.">*</span></label>
                         <input 
                            type="text"
                            id="edit-submitted-city-town-province"
                            name="city_town_province" 
                            value={formData.city_town_province}
                            size="60" 
                            maxlength="128" 
                            className={fieldErrors.city_town_province ? 'input-error' : ''}
                            style={inputStyle.city_town_province}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                              <label htmlFor="edit-submitted-state">State <span className="form-required" title="This field is required.">*</span></label>
                                 <select  id="edit-submitted-state" name="state" value={formData.state}  onChange={handleChange}
                                    className={`smww-appn state-field ${fieldErrors.state ? 'input-error' : ''}`}
                                    style={inputStyle.state}
                                 >
                                    <option value="">Select State</option>
                                    {Object.keys(statelist).map(state => {
                                    return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                                    })}
                                </select>
                        </div>
                           <div className="form-item">
                        <label htmlFor="edit-submitted-zip-post-code">Zip/Post Code <span className="form-required" title="This field is required.">*</span></label>
                         <input 
                            type="text"
                            id="edit-submitted-zip-post-code"
                            name="zip_post_code" 
                            value={formData.zip_post_code}
                            size="60" 
                            maxlength="128" 
                            className={fieldErrors.zip_post_code ? 'input-error' : ''}
                            style={inputStyle.zip_post_code}
                            onChange={handleChange}
                        />
                        </div>
                           <div className="form-item">
                            <label htmlFor="edit-submitted-country">Country <span className="form-required" title="This field is required.">*</span></label>
                                    <Select                                 
                                    id="edit-submitted-country" 
                                    name="country" 
                                    searchable={true}                                
                                    clearable={true} 
                                    clearOnBlur={true} 
                                    clearOnSelect={true}
                                    backspaceDelete={true}  
                                    className={`select-country ${fieldErrors.country ? 'input-error' : ''}`}                               
                                    style={{
                                        backgroundColor: '#ffffff',
                                        width: '87.8%',
                                        borderRadius: 5,
                                        ...inputStyle.country
                                    }}                                                  
                                    options={countriesList}                                 
                                    onChange={(val) => {
                                    if(val.length == 0) {
                                        console.log(val);
                                    }
                                    else{
                                        setSelectedCountry(val);
                                    handleChange(
                                        { target: { value: val[0]['value'], name: 'country' } }
                                    )
                                    
                                    }}
                                    }
                                    onDropdownOpen={handleOpen}
                                    values={selectedcountry}                                 
                                    />
                            </div>
                                <div className="form-item phone-input">
                                    <label htmlFor="edit-submitted-phone">Phone <span className="form-required" title="This field is required.">*</span></label>
                                            <PhoneInput
                                                international
                                                countryCallingCodeEditable={false}
                                                placeholder="201-555-0123"
                                                className={`smww-appn ${fieldErrors.phone ? 'input-error' : ''}`} 
                                                style={inputStyle.phone}
                                                value={formData.phone}
                                                defaultCountry={formData.phoneCountry || 'US'}
                                                onCountryChange={(country) => {
                                                    setFormData((prev) => ({
                                                    ...prev,
                                                    phoneCountry: country,
                                                    }));
                                                }}
                                                onChange={(phone) => {
            
                                                if (!phone) {
                                                    console.log('Phone input cleared.');
                                                    setFormData((prev) => ({
                                                    ...prev,
                                                    phone: '',
                                                    }));
                                                    return;
                                                }
            
                                                const digitsOnly = phone.replace(/\D/g, '');
            
                                                let codeLength = 0;
            
                                                if (formData.phoneCountry) {
                                                    codeLength = getCountryCallingCode(formData.phoneCountry).length;
                                                } else {
                                                    const match = digitsOnly.match(/^\d{1,3}/);
                                                    if (match) {
                                                    codeLength = match[0].length;
                                                    }
                                                }
            
                                                if (digitsOnly.length <= codeLength) {
                                                    setFormData((prev) => ({
                                                    ...prev,
                                                    phone: '',
                                                    }));
                                                } else {
                                                    setFormData((prev) => ({
                                                    ...prev,
                                                    phone: phone,
                                                    }));
                                                }
                                                }}
            
                                                />
                        </div>
                         <div className="form-item">
                        <label htmlFor="edit-submitted-email">Email <span className="form-required" title="This field is required.">*</span></label>
                        <input 
                            type="text" 
                            id="edit-submitted-email" 
                            name="email" 
                            value={formData.email} 
                            size="60" 
                            className={fieldErrors.email ? 'input-error' : ''}
                            style={inputStyle.email}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-retype-email">Retype Email <span className="form-required" title="This field is required.">*</span></label>
                        <input 
                            type="text" 
                            id="edit-submitted-retype-email" 
                            name="retype_email" 
                            value={formData.retype_email} 
                            size="60"  
                            className={fieldErrors.retype_email ? 'input-error' : ''}
                            style={inputStyle.retype_email}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="description">(Please confirm your email address by entering it again.)</div>
                          <div className="form-item">
                        <label htmlFor="edit-submitted-sport-played">
                          Sport Played <span className="form-required" title="This field is required.">*</span>
                        </label>     
                        <select
                          id="edit-submitted-sport-played"
                          name="sport_played"
                          value={formData.sport_played}  
                          className={fieldErrors.sport_played ? 'input-error' : ''}
                          style={inputStyle.sport_played}
                          onChange={handleChange}
                        >
                            <option value="">- Select -</option>

                        {sportsOptions.map((sport) => (
                            <option key={sport.value} value={sport.value}>
                            {sport.label}
                            </option>
                        ))}

                        </select>
                      </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-specific-sport">Specific Sport </label>
                        <input 
                            type="text" 
                            id="edit-submitted-specific-sport" 
                            name="specific_sport" 
                            value={formData.specific_sport} 
                            size="60"  
                            maxLength={128}
                            className={fieldErrors.specific_sport ? 'input-error' : ''}
                            style={inputStyle.specific_sport}
                            onChange={handleChange}
                        />
                        </div>
                        <div class="description">(Please fill in your specific sport if you have chosen Track &amp; Field, Olympic Sports, Motor Sports, Extreme Sports or Other.)</div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-positions-played">Primary Position <span className="form-required" title="This field is required.">*</span></label>
                        <input 
                            type="text" 
                            id="edit-submitted-positions-played" 
                            name="positions_played" 
                            value={formData.positions_played} 
                            size="60"  
                            maxLength={128}
                            className={fieldErrors.positions_played ? 'input-error' : ''}
                            style={inputStyle.positions_played}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-university-attended">University Attended </label>
                        <input 
                            type="text" 
                            id="edit-submitted-university-attended" 
                            name="university_attended" 
                            value={formData.university_attended} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-high-school">High School </label>
                        <input 
                            type="text" 
                            id="edit-submitted-high-school" 
                            name="high_school" 
                            value={formData.high_school} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-high-school-city">High School City </label>
                        <input 
                            type="text" 
                            id="edit-submitted-high-school-city" 
                            name="high_school_city" 
                            value={formData.high_school_city} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="form-item">
                        <label htmlFor="edit-submitted-high-school-state">High School State </label>
                        <input 
                            type="text" 
                            id="edit-submitted-high-school-state" 
                            name="high_school_state" 
                            value={formData.high_school_state} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        />
                        </div>
                            <div className="">
                          <label htmlFor="edit-submitted-awards">Awards </label>
                          <div>
                               <textarea
                                    className="form-textarea-wrapper resizable textarea-processed resizable-textarea form-textarea"
                                    type="text"
                                    id="edit-submitted-awards"
                                    name="awards"
                                    cols={60}
                                    rows={5}
                                    value={formData.awards}
                                    onChange={handleChange}
                                  ></textarea>
                              <div className="grippie" style={{
                                background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                          </div>
                      </div>
                        <div className="form-item">
                        <div className='label-wrapper'><label className="experience-label" htmlFor="edit-submitted-professional-experience">Have you played for a professional team or academy? If so, which was your most recent one? </label></div>
                        <input 
                            type="text" 
                            id="edit-submitted-professional-experience" 
                            name="professional_experience" 
                            value={formData.professional_experience} 
                            size="60"  
                            maxLength={128}
                            onChange={handleChange}
                        />
                        </div>
                        <div className="">
                          <label htmlFor="edit-submitted-test-info">Test Info (40 time, 60 time, arm speed etc.) </label>
                          <div>
                               <textarea
                                    className="form-textarea-wrapper resizable textarea-processed resizable-textarea form-textarea"
                                    type="text"
                                    id="edit-submitted-test-info"
                                    name="test_info"
                                    cols={60}
                                    rows={5}
                                    value={formData.test_info}
                                    onChange={handleChange}
                                  ></textarea>
                              <div className="grippie" style={{
                                background: `#eee url(${process.env.PUBLIC_URL}/images/grippie.png) no-repeat center 2px`,
                            }}></div>
                          </div>
                      </div>
                       <div className="form-item webform-component webform-component-date webform-component--date-of-birth">
                        <label>
                            Date of Birth <span className="form-required" title="This field is required.">*</span>
                        </label>

                        <div className="webform-container-inline webform-datepicker">
                        <div className="form-item form-type-select form-item-submitted-date-of-birth-year">
                            <select 
                            name="year" 
                            value={formData.year} 
                            onChange={handleDropdownChange}
                            className={fieldErrors.year ? 'input-error' : ''}
                            style={inputStyle.year}
                            >
                            <option value="">Year</option>
                            {years.map((yr) => (
                                <option key={yr} value={yr}>{yr}</option>
                            ))}
                            </select>
                        </div>

                        <div className="form-item form-type-select form-item-submitted-date-of-birth-month">
                            <select 
                                name="month" 
                                value={formData.month} 
                                onChange={handleDropdownChange}
                                className={fieldErrors.month ? 'input-error' : ''}
                                style={inputStyle.month}
                                >
                            <option value="">Month</option>
                            {months.map((m) => (
                                <option key={m.value} value={m.value}>{m.label}</option>
                            ))}
                            </select>
                        </div>

                        <div className="form-item form-type-select form-item-submitted-date-of-birth-day">
                            <select 
                            name="day" 
                            value={formData.day} 
                            onChange={handleDropdownChange}
                            className={fieldErrors.day ? 'input-error' : ''}
                            style={inputStyle.day}
                            >
                            <option value="">Day</option>
                            {days.map((d) => (
                                <option key={d} value={d}>{d}</option>
                            ))}
                            </select>
                        </div>

                            {/* Calendar Icon */}
                            <img
                            src="/basic/web/images/scout/calendar.png"
                            className='form-item'
                            alt="Open calendar"
                            style={{ width: 18, height: 18, cursor: "pointer" }}
                            onClick={() => setCalendarOpen(true)}
                            />

                            {calendarOpen && (
                            <DatePicker
                            selected={
                                formData.year && formData.month && formData.day
                                ? new Date(formData.year, formData.month - 1, formData.day)
                                : null
                            }
                            onChange={handleCalendarSelect}
                            inline
                            showYearDropdown
                            scrollableYearDropdown
                            minDate={new Date(1944, 0, 1)}
                            maxDate={new Date(maxYear, 11, 31)} // limit to maxYear
                            />

                            )}
                        </div>
                        </div>
                        <div style={{"clear":"both"}}></div>
                          <fieldset className="webform-component-fieldset webform-component--height-units form-wrapper">
                            <legend>
                              <span className="">Height</span><span className="form-required" title="This field is required.">*</span>
                            </legend>
                            <div className="fieldset-wrapper">
                              {formData.height_unit === 'Metric' ? (
                              <>
                              <div className="height_in_metric form-item webform-component--height-units--height webform-component--height-units--height-cm">
                                {/* <label htmlFor="edit-submitted-height-units-height">Cm </label> */}
                                  <input 
                                    type="text" 
                                    id="edit-submitted-height-units-height"
                                    name="height" 
                                    value={formData.height}
                                    size="60" 
                                    maxLength="128" 
                                    className={fieldErrors.height ? 'input-error' : ''}
                                    style={inputStyle.height}
                                    onChange={handleChange}
                                    />
                                  
                                </div>
                                </>
                                ) : (
                                  <>
                                <div className="height_in_imperial form-item webform-component--height-units--height webform-component--height-units--height-ft">
                                  {/* <label htmlFor="edit-submitted-height-units-ft">Ft </label> */}
                                <input 
                                type="text"
                                 id="edit-submitted-height-units-ft" 
                                 name="ft" 
                                 step="any" 
                                 value={formData.ft || ""}
                                 className={fieldErrors.ft ? 'input-error' : ''}
                                 style={inputStyle.ft}
                                 onChange={handleChange}
                                 />
                                
                                </div>
                                <div class="height_in_imperial form-item webform-component--height-units--height webform-component--height-units--height-in">
                                  {/* <label for="edit-submitted-height-units-in">In </label> */}
                                <input
                                 type="text" 
                                 id="edit-submitted-height-units-in" 
                                 name="in" 
                                 step="any" 
                                 value={formData.in || ""}
                                 className={fieldErrors.in ? 'input-error' : ''}
                                 style={inputStyle.in}
                                 onChange={handleChange}
                                 />
                                 
                                </div>
                                </>
                              )}
                              <div className="form-radios">
                                <div className="form-item form-type-radio webform-component--height-units--height-unit">
                                     <input
                                      type="radio"
                                      name="height_unit"
                                      value="Imperial"
                                      checked={formData.height_unit === 'Imperial'}
                                      onChange={handleChange}
                                      style={{verticalAlign:"bottom"}}
                                    />
                                  <label htmlFor="unit-imperial" className="option">
                                    Imperial
                                  </label>
                                </div>

                                <div className="form-item form-type-radio webform-component--height-units--height-unit">
                                    <input
                                      type="radio"
                                      name="height_unit"
                                      value="Metric"
                                      checked={formData.height_unit === 'Metric'}
                                      onChange={handleChange}
                                      style={{verticalAlign:"bottom"}}
                                    />
                                  <label htmlFor="unit-metric" className="option">
                                    Metric
                                  </label>
                                </div>
                              </div>
                            </div>
                            </fieldset>
                           
                          <p style={{"clear":"both"}}>If you are interested in Name, Image, and Likeness opportunities, please fill in the following:</p>
                         <div className="form-item  webform-container-inline">
                          <label htmlFor="weight">
                            Weight <span className="form-required" title="This field is required.">*</span>
                          </label>

                          <input
                            type="text"
                            id="weight"
                            name="weight"
                            value={formData.weight}
                            onChange={handleChange}
                            className={`form-text required ${fieldErrors.weight ? "input-error" : ""}`}
                          />
                        </div>
                        <div className='weight-radio'>
                         <input
                                type="radio"
                                id="weight-unit-lb"
                                name="weight_unit"
                                value="lb"
                                checked={formData.weight_unit === "lb"}
                                onChange={handleChange}
                                className="form-radio"
                              />
                              <label className="option" htmlFor="weight-unit-lb">
                                lb
                              </label>
                               <input
                                type="radio"
                                id="weight-unit-kg"
                                name="weight_unit"
                                value="kg"
                                checked={formData.weight_unit === "kg"}
                                onChange={handleChange}
                                className="form-radio"
                              />
                              <label className="option" htmlFor="weight-unit-kg">
                                kg
                              </label>
                              </div>
                          <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-facebook-url">Facebook URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-facebook-url"
                            name="facebook_url"
                             value={formData.facebook_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-facebook-followers">Facebook Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-facebook-followers"
                            name="facebook_followers"
                             value={formData.facebook_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-instagram-url">Instagram URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-instagram-url"
                            name="instagram_url"
                             value={formData.instagram_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-instagram-followers">Instagram Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-instagram-followers"
                            name="instagram_followers"
                             value={formData.instagram_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-your-linkedin-url">LinkedIn URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-your-linkedin-url"
                            name="your_linkedin_url"
                             value={formData.your_linkedin_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-linkedin-followers">LinkedIn Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-linkedin-followers"
                            name="linkedin_followers"
                             value={formData.linkedin_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-tiktok-url">TikTok URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-tiktok-url"
                            name="tiktok_url"
                             value={formData.tiktok_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-tiktok-followers">TikTok Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-tiktok-followers"
                            name="tiktok_followers"
                             value={formData.tiktok_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-twitter-url">Twitter URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-twitter-url"
                            name="twitter_url"
                             value={formData.twitter_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                            <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-twitter-followers">Twitter Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-twitter-followers"
                            name="twitter_followers"
                             value={formData.twitter_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                               <div className="social_media_left form-item">
                            <label htmlFor="edit-submitted-youtube-url">YouTube URL </label>
                          <input 
                          type="text"
                           id="edit-submitted-youtube-url"
                            name="youtube_url"
                             value={formData.youtube_url}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                               <div className="social_media_right form-item">
                            <label htmlFor="edit-submitted-youtube-followers">YouTube Followers # </label>
                          <input 
                          type="text"
                           id="edit-submitted-twitter-followers"
                            name="youtube_followers"
                             value={formData.youtube_followers}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                          </div>
                          <p>Please provide contact information for someone who would verify your athletic ability.&nbsp;<br/>
                            (This should be a coach, scout, university representative)</p>
                             <fieldset className={`webform-component-fieldset collapsible ${reference1 ? "" : ""}`}>
                              <legend onClick={() => setReference1(!reference1)} style={{ cursor: "pointer" }}>
                                <span className="fieldset-legend">
                                <a href="#" target='blank'> <span className="fieldset-title">
                                    {reference1 ? "" : ""}  <span className="arrow">▼</span> 1st reference
                                  </span></a>
                                </span>
                              </legend>

                          {/* Wrapper visible only when open */}
                          {reference1 && (
                            <div className="fieldset-wrapper">

                              <div className="form-item webform-component webform-component--1st-reference--1st-reference-name">
                                    <label htmlFor="edit-submitted-1st-reference-1st-reference-name">First Name </label>
                                  <input
                                   type="text" 
                                  id="edit-submitted-1st-reference-1st-reference-name" 
                                  name="1st_reference_name" 
                                  value={formData["1st_reference_name"]}
                                  size="60" 
                                  maxLength="128"
                                  onChange={handleChange}
                                   />
                                  </div>

                            <div className="form-item webform-component webform-component--1st-reference--1st-reference-last-name">
                              <label htmlFor="edit-submitted-1st-reference-1st-reference-last-name">Last Name </label>
                            <input 
                            type="text" 
                            id="edit-submitted-1st-reference-1st-reference-last-name" 
                            name="1st_reference_last_name" 
                            value={formData["1st_reference_last_name"]}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                            </div>
                            <div className="form-item webform-component webform-component--1st-reference--job-title-1">
                              <label htmlFor="edit-submitted-1st-reference-job-title-1">Job title (coach, scout, etc.) </label>
                            <input 
                            type="text"
                             id="edit-submitted-1st-reference-job-title-1"
                              name="job_title_1"
                               value={formData["job_title_1"]}
                                size="60"
                                 maxLength="128" 
                                  onChange={handleChange}
                                 />
                            </div>
                            <div className="form-item webform-component webform-component--1st-reference--team-or-club-1">
                              <label htmlFor="edit-submitted-1st-reference-team-or-club-1">Team or club </label>
                            <input 
                            type="text"
                             id="edit-submitted-1st-reference-team-or-club-1"
                              name="team_or_club_1" 
                               value={formData["team_or_club_1"]}
                              size="60" 
                              maxLength="128" 
                              onChange={handleChange}
                              />
                            </div>
                            <div className="form-item webform-component webform-component--1st-reference--email-address-1">
                              <label htmlFor="edit-submitted-1st-reference-email-address-1">Email Address </label>
                            <input
                             type="text" 
                             id="edit-submitted-1st-reference-email-address-1" 
                             name="email_address_1" 
                             value={formData["email_address_1"]}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                            </div>
                            <div className="form-item webform-component webform-component--1st-reference--1st-reference-phone">
                              <label htmlFor="edit-submitted-1st-reference-1st-reference-phone">Phone </label>
                            <input 
                            type="text"
                             id="edit-submitted-1st-reference-1st-reference-phone"
                              name="1st_reference_phone"
                               value={formData["1st_reference_phone"]} 
                               size="60" 
                               maxLength="128"
                                onChange={handleChange}
                                />
                            </div>
                           </div>
                          )}
                        </fieldset>
                         <fieldset className={`webform-component-fieldset collapsible ${reference2 ? "" : ""}`}>
                              <legend onClick={() => setReference2(!reference2)} style={{ cursor: "pointer" }}>
                                <span className="fieldset-legend">
                                  <a href="#" target='blank'><span className="fieldset-title">
                                    {reference2 ? "" : ""} <span className="arrow">▼</span> 2nd reference (optional)
                                  </span>
                                  </a>
                                </span>
                              </legend>

                          {/* Wrapper visible only when open */}
                          {reference2 && (
                            <>
                           <div className="fieldset-wrapper">
                            <div className="form-item webform-component webform-component--2nd-reference--2nd-reference-name">
                              <label htmlFor="edit-submitted-2nd-reference-2nd-reference-name">First Name </label>
                            <input 
                            type="text"
                             id="edit-submitted-2nd-reference-2nd-reference-name" 
                             name="2nd_reference_name" 
                             value={formData["2nd_reference_name"]}
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                            />
                            </div>

                        <div className="form-item webform-component webform-component--2nd-reference--2nd-reference-last-name">
                          <label htmlFor="edit-submitted-2nd-reference-2nd-reference-last-name">Last Name </label>
                        <input 
                        type="text" 
                        id="edit-submitted-2nd-reference-2nd-reference-last-name"
                         name="2nd_reference_last_name" 
                         value={formData["2nd_reference_last_name"]}
                          size="60" 
                          maxLength="128" 
                          onChange={handleChange}
                          />
                        </div>
                        <div className="form-item webform-component webform-component--2nd-reference--job-title-2">
                          <label htmlFor="edit-submitted-2nd-reference-job-title-2">Job title (coach, scout, etc.) </label>
                        <input
                         type="text"
                          id="edit-submitted-2nd-reference-job-title-2"
                           name="job_title_2"
                            value={formData["job_title_2"]}
                             size="60" 
                             maxLength="128"
                            onChange={handleChange}
                              />
                        </div>
                        <div className="form-item webform-component webform-component--2nd-reference--team-or-club-2">
                          <label htmlFor="edit-submitted-2nd-reference-team-or-club-2">Team or club </label>
                        <input
                         type="text" 
                         id="edit-submitted-2nd-reference-team-or-club-2"
                          name="team_or_club_2" 
                          value={formData["team_or_club_2"]} 
                          size="60" 
                          maxLength="128" 
                          onChange={handleChange}
                          />
                        </div>
                        <div className="form-item webform-component webform-component--2nd-reference--email-address-2">
                          <label htmlFor="edit-submitted-2nd-reference-email-address-2">Email Address </label>
                        <input
                         type="text" 
                         id="edit-submitted-2nd-reference-email-address-2"
                          name="email_address_2" 
                          value={formData["email_address_2"]}
                           size="60" 
                           maxLength="128"
                            onChange={handleChange}
                            />
                        </div>
                        <div className="form-item webform-component webform-component--2nd-reference--2nd-reference-phone">
                          <label htmlFor="edit-submitted-2nd-reference-2nd-reference-phone">Phone </label>
                        <input
                         type="text"
                          id="edit-submitted-2nd-reference-2nd-reference-phone" 
                          name="2nd_reference_phone"
                           value={formData["2nd_reference_phone"]} 
                           size="60" 
                           maxLength="128"
                           onChange={handleChange}
                            />
                        </div>

                          </div>
                          </>
                          )}
                        </fieldset>
                         <fieldset className={`webform-component-fieldset collapsible ${reference3 ? "" : ""}`}>
                              <legend onClick={() => setReference3(!reference3)} style={{ cursor: "pointer" }}>
                                <span className="fieldset-legend">
                                 <a href="#" target='blank'><span className="fieldset-title">
                                    {reference3 ? "" : ""} <span className="arrow">▼</span>  3rd reference (optional)
                                  </span></a>
                                </span>
                              </legend>

                          {/* Wrapper visible only when open */}
                          {reference3 && (
                            <>
                            <div className="fieldset-wrapper">
                              <div className="form-item webform-component webform-component--3rd-reference--3rd-reference-name">
                              <label htmlFor="edit-submitted-3rd-reference-3rd-reference-name">First Name </label>
                            <input
                             type="text" 
                             id="edit-submitted-3rd-reference-3rd-reference-name" 
                             name="3rd_reference_name" 
                             value={formData["3rd_reference_name"]}
                              size="60" 
                              maxLength="128" 
                               onChange={handleChange}
                              />
                            </div>
                            <div className="form-item webform-component webform-component--3rd-reference--3rd-reference-last-name">
                              <label htmlFor="edit-submitted-3rd-reference-3rd-reference-last-name">Last Name </label>
                            <input
                             type="text" 
                             id="edit-submitted-3rd-reference-3rd-reference-last-name" 
                             name="3rd_reference_last_name"
                              value={formData["3rd_reference_last_name"]}
                               size="60" 
                               maxLength="128" 
                                onChange={handleChange}
                               />
                            </div>
                            <div className="form-item webform-component webform-component--3rd-reference--job-title-3">
                              <label htmlFor="edit-submitted-3rd-reference-job-title-3">Job title (coach, scout, etc.) </label>
                            <input
                             type="text"
                              id="edit-submitted-3rd-reference-job-title-3" 
                              name="job_title_3" 
                              value={formData["job_title_3"]} 
                              size="60" 
                              maxLength="128"
                               onChange={handleChange}
                               />
                            </div>
                            <div className="form-item webform-component webform-component--3rd-reference--team-or-club-3">
                              <label htmlFor="edit-submitted-3rd-reference-team-or-club-3">Team or club </label>
                            <input 
                            type="text"
                             id="edit-submitted-3rd-reference-team-or-club-3" 
                             name="team_or_club_3" 
                             value={formData["team_or_club_3"]} 
                             size="60" 
                             maxLength="128" 
                              onChange={handleChange}
                             />
                            </div>
                            <div className="form-item webform-component webform-component--3rd-reference--email-address-3">
                              <label htmlFor="edit-submitted-3rd-reference-email-address-3">Email Address </label>
                            <input 
                            type="text" 
                            id="edit-submitted-3rd-reference-email-address-3"
                             name="email_address_3" 
                             value={formData["email_address_3"]}
                             size="60" 
                             maxLength="128" 
                              onChange={handleChange}
                             />
                            </div>
                            <div className="form-item webform-component webform-component--3rd-reference--3rd-reference-phone">
                              <label htmlFor="edit-submitted-3rd-reference-3rd-reference-phone">Phone </label>
                            <input 
                            type="text" 
                            id="edit-submitted-3rd-reference-3rd-reference-phone" 
                            name="3rd_reference_phone"
                            value={formData["3rd_reference_phone"]} 
                             size="60" 
                             maxLength="128" 
                             onChange={handleChange}
                             />
                            </div>
                            </div>
                            </>
                          )}
                        </fieldset>
                        <div className="webform-component webform-component-markup webform-component--to-ensure">
                          <p>NFL prospects will only be contacted by a certified NFLPA Contract Advisor.</p>

                          </div>

                         <div className="adduser-form-actions">
                          <input type="submit" id="edit-submit" value={buttonText}  disabled={isButtonDisabled} className="form-submit"  />
                        </div>
                        {/* Bottom Navigation */}
                                                   <nav>
                                                     {/* {prevId && */}
                                                           <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/node/1080/submission/"+prevId}>Previous submission</a>
                                                      {/* }  */}
                                                       {/* {nextId &&  */}
                                                           <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN+"/node/1080/submission/"+nextId}>Next submission</a>
                                                       {/* } */}
                                                   </nav>
                 </form>  
      </div>}
      </div> 
      {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                            <>
                                <div  className= {toggle === 3? "show-content" : "content"}>
                                    <form onSubmit={handleDelete}>
                                    <div>Are you sure you want to delete this submission?
                                        <div className="form-actions form-wrapper" id="edit-actions">
                                            <input type="submit" name="" value="Delete" className="form-submit" />
                                            <a href={"/node/1080/submission/"+id} style={{marginLeft: "5px"}}>Cancel</a>
                                        </div>
                                    </div>
                                    </form>
                                </div>
                            </>
                        }
      </div>
        <div class="right">
          <SalespersonSidebar />
        </div> 
  <div className='clear'></div>
    
    
  </div>
  );
};

export default LookingForAgentEdit;